import _http_v1 from '@packs/http_requests/_http_v1'
import store from '../../../store/main_config_store'

export default function AvgHistOpt(opts={}){
    BaseConstructor.call(this)
    let {container,latLng} = opts
    let elements = {}
    let context = this
    let clickable = true

    this.getElement = _ =>{
        return elements.container
    }

    this.generate = () =>{
        
    }

    this.update = () =>{

    }

    init()

    function init(){
        elements.container = context.createElement('div', 'avghist-opt-container list-opt-container', '<i class="fas fa-database mr-2"></i>Média mensal Histórica')

        $(elements.container).on('click', _=>{
            let months = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez']
            if(clickable){
                clickable = false
                $(elements.container).html('carregando..')
                _http_v1.request('historical_measurements/avg_from_point', 'GET', {lat:latLng.lat, lng: latLng.lng}).then(data=>{
                    if(data){
                        let date = moment(store.getDate() || undefined)
                        let _date = date || moment()
                        let avg = data['avg_' + months[_date.month()]]
                        $(elements.container).html((avg && avg != -99999) ? '<span style="text-transform:capitalize">Média de ' +months[_date.month()] + ':</span> <span class="text-primary font-weight-bold">'+avg.toFixed(1) + ' mm</span>' : 'Erro :(')
                    } else {
                        $(elements.container).html('Erro :(')
                    }
                    
                })
            }
            
        })

    }
}

AvgHistOpt.prototype = Object.create(BaseConstructor.prototype)